import { ChangeDetectorRef, Component, EventEmitter, Injectable, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, Platform } from '@ionic/angular';
import { API } from 'aws-amplify';
import { Subscription, timer, Observable } from 'rxjs';
import { LobbypageService } from '../../services/lobbypage.service';
import { HelperService } from '../../shared/services/helper_service';
import { environment } from '../../../environments/environment';

// Slider
import { IonSlides } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from 'src/app/shared/services/auth_service';
@Injectable()
export class MyService {
  getCounter(tick) {
    return timer(0, tick);
  }
}

@Component({
  selector: 'app-cricket',
  templateUrl: './cricket.page.html',
  styleUrls: ['./cricket.page.scss'],
  providers: [MyService]
})
export class CricketPage implements OnInit, OnDestroy {
  public env = environment;
  Namma11CupLogo = '/mobile/logos/appcuplogo.png';
  newDate = new Date();
  skeleton: number[] = [1, 2, 3, 4]
  matches: any[] = [];
  filteredMatches: any[] = [];
  currentTimeInSeconds: number = new Date().getTime();
  firstCurrentDate: Date;
  secondCurrentDate: Date;
  hoursCurrent: number[] = [];
  minutesCurrent: number[] = [];
  secondCurrent: number[] = [];
  IntervalVar = [];
  filterArray = [];
  _tempFilter: any[] = [];
  isLoading = true;
  delayedMinutes : number ;
  Bannerlist : any[] = [];
  countDown: Subscription[];
  counter: any = {};
  tick = 1000;
  cacheCleartimestamp : number = new Date().getTime();
  walletBalance: any;
  withdrawalStatus: any;
  phoneNumberVerified : boolean = false;
  emailVerified : boolean = false;
  panVerified : boolean;
  bankVerified : boolean;

  // private pauseListener: Subscription;
  // private resumeListener: Subscription;
  // private ionWillEnterSubscription: Subscription;
  @Input() ionWillEnter: Observable<boolean>;
  @Output() myOutput: EventEmitter<any> = new EventEmitter();
  @Input() set selectedFilter(value) {
    this._tempFilter = value;
    this.filterList();
  }
  get selectedFilter() {
    return this._tempFilter;
  }
  slideOpts = {
    initialSlide: 0,
    slidesPerView: 1.02,
    spaceBetween: 5,
    speed: 400,
    // loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    pagination : {
      el: '.swiper-pagination',
      type: 'bullets' ,
      clickable: true
    }
  };

  constructor(
    private lobbyService: LobbypageService,
    private navCtrl: NavController,
    private helperServis: HelperService,
    private myService: MyService,
    private router: Router,
    private httpClient: HttpClient,
    private changeRef: ChangeDetectorRef,
    private auth: AuthService,
    public helperService: HelperService,
  ) {
    this.panVerified = false;
    this.bankVerified = false;
  }

  public offersPage(): void {
    this.router.navigate(['/offerpage'])
  }

     //Move to Next slide
  slideNext(object, slideView) {
    slideView.slideNext(500).then(() => {
      this.checkIfNavDisabled(object, slideView);
    });
  }

  //Move to previous slide
  slidePrev(object, slideView) {
    slideView.slidePrev(500).then(() => {
      this.checkIfNavDisabled(object, slideView);
    });;
  }

    //Method called when slide is changed by drag or navigation
  SlideDidChange(object, slideView) {
    this.checkIfNavDisabled(object, slideView);
  }
  
  //Call methods to check if slide is first or last to enable disbale navigation  
  checkIfNavDisabled(object, slideView) {
    this.checkisBeginning(object, slideView);
    this.checkisEnd(object, slideView);
  }
  checkisBeginning(object, slideView) {
    slideView.isBeginning().then((istrue) => {
      object.isBeginningSlide = istrue;
    });
  }
  checkisEnd(object, slideView) {
    slideView.isEnd().then((istrue) => {
      object.isEndSlide = istrue;
    });
  }

  ngOnInit() {
    this.getBanners()
    this.getUserWalletBalance();
    // this.ionWillEnterSubscription = this.ionWillEnter.subscribe((data: boolean) => {
    //   console.warn(`ionWillEnter: ${data}`);
    //   if (data) {
    //     this.doRefresh();
    //   } else {
    //     this.ngOnDestroy();
    //   }
    // });

    // this.pauseListener = this.platform.pause.subscribe(async () => {
    //   this.helperServis.presentToast('Pause event detected');
    //   // this.unSubscribeCoundown();
    // });  

    // this.resumeListener = this.platform.resume.subscribe(async () => {
    //   this.helperServis.presentToast('Resume event detected');
    //   // this.doRefresh();
    // });
  }

  afterslidesLoad(slides) {
    slides.startAutoplay();
  }

  withdrawamount(money){
    if(this.panVerified && this.bankVerified){
      if(!this.withdrawalStatus && this.withdrawalStatus == 3){
        this.router.navigate(['/withdrawalmoney'], { queryParams: { matchDetails: JSON.stringify(money) } });  
      }else if(this.withdrawalStatus == 0){
        this.router.navigate(['/withdrawalpending'],{ queryParams: { matchDetails: JSON.stringify(money),withdrawalStatus:this.withdrawalStatus } });
      }else{
        this.router.navigate(['/withdrawalmoney'], { queryParams: { matchDetails: JSON.stringify(money) } });  
      }
    }
    else{    
      this.helperService.presentToast("Verify PAN and Bank");
      this.router.navigate(['/profile/verify'],{queryParams: {routerback:"mywallet"}});
    }
  }

  getUserWalletBalance() {
    const apiName = 'walletApi';
    const path = '/wallet/balance';
    const myInit = {
      headers: {},
      response: true,
    };
    API.get(apiName, path, myInit)
      .then(response => {
        this.walletBalance = response['data'].data;
        console.log(response);
        this.withdrawalStatus = this.walletBalance.withdrawalStatus;
        this.phoneNumberVerified = this.walletBalance.phoneNumberVerified ;
        this.emailVerified = this.walletBalance.emailVerified;
        this.bankVerified = this.walletBalance.bankVerified ;
        this.panVerified = this.walletBalance.panVerified;
      })
      .catch(error => {
        console.log(error);
      });
  }

  getBanners(){
    const headers = new HttpHeaders();
    headers.append('Cache-control', 'no-cache');
    headers.append('Cache-control', 'no-store');
    headers.append('Expires', '0');
    headers.append('Pragma', 'no-cache');
      this.httpClient.get(`${this.env.global_settings}/site/assets/banners.json?${(new Date().getTime())}`,{ headers: headers} ).subscribe((data: any) => {
        this.Bannerlist = data?.homebanners || [];
        console.log(this.Bannerlist);
    }, error => {
      console.log(error);
    });
  }

  async Navigatebanner(router){
    if(router.routerpage.includes('contest-detail')){
      const match = await this.matches.find(e => e.matchId == Number(router.routerpage.split('/')[2]));
      if(match){
        this.router.navigate(["/contest-detail"], {
          queryParams: {
            isFromDeepLink: true,
            deepLinkMatchId: router.routerpage.split('/')[2],
            deepLinkContestId: router.routerpage.split('/')[3],
          },
        });
      }
    } else if(router.routerpage.includes('contest-listing')){
      const match = await this.matches.find(e => e.matchId == Number(router.routerpage.split('/')[2]));
      if(match){
        this.router.navigate(['contest-listing'], { queryParams: { matchDetails: JSON.stringify(match) } });
      }
    } else if(router.routerpage.includes('withdrawal')){
       this.withdrawamount(this.walletBalance);
    }else if(router.routerpage.includes('instagram')){
      window.location.href='https://www.instagram.com/namma11official/';
    }else if(router.routerpage.includes('facebook')){
      window.location.href='https://www.facebook.com/namma11official/';
    }else if(router.routerpage.includes('twitter')){
      window.location.href='https://www.twitter.com/namma11official/';
    }
     else {
      console.log('ESLE=>',router.routerpage);
      this.router.navigate([router.routerpage])
    }
    
  }

  getMatches() {
    // console.log("call getMatches1");
    const apiName = 'matchesApi';
    const path = `/matches/?${this.currentTimeInSeconds}&gameId=1&sportId=1`;
    const myInit = {
      headers: {},
      response: true,
      queryStringParameters: {}
    };
    this.isLoading = true;
    this.auth.getReq(apiName, path, myInit).then((data)=>{
      data?.data?.data?.matches.sort((a, b) => b.isPinned - a.isPinned || a.timeStampStart - b.timeStampStart);
      this.matches = data?.data?.data?.matches;
      this.filterList()
      this.isLoading = false;
      this.getCurrentTimer();
    }).catch((error)=>{
      this.isLoading = false;
      console.log(error);
    })
  }

  filterList() {
    if (this.selectedFilter.length) {
      this.filteredMatches = this.matches.filter(match => {
        return this.selectedFilter.indexOf(match.series) != -1;
      })
    } else {
      this.filteredMatches = this.matches;
    }
  }

  intToString(num) {
    const si = [
      { v: 1E3, s: " K" },
      { v: 1E5, s: " Lakhs" },
      { v: 1E9, s: " C" },
      { v: 1E12, s: " T" },
      { v: 1E15, s: " P" },
      { v: 1E18, s: " E" }
    ];
    let i;
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].v) {
        break;
      }
    }
    return (num / si[i].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[i].s;
  }

  unixTime(unixtime) {
    var u = new Date(unixtime * 1000);
    return u.toLocaleDateString();
  }

  getCurrentTimer() {
    this.counter = {};
    this.countDown = [];
    for (let i = 0; i < this.filteredMatches.length; i++) {
      if (this.filterArray.indexOf(this.filteredMatches[i].series) === -1) {
        this.filterArray.push(this.filteredMatches[i].series);
      }
      const matchId = this.filteredMatches[i].matchId;
      const start = new Date().getTime();
      const end = new Date(this.filteredMatches[i].timeStampStart * 1000).getTime();
      const diff = end - start;
      this.counter[matchId] = Math.floor(diff / 1000);
      const subs = this.myService.getCounter(this.tick).subscribe(() => {
        this.counter[matchId]--;
        // console.log(`Index: ${i}, Counter: ${this.counter[matchId]}, match: ${this.filteredMatches[i].matchName}`);
        this.changeRef.detectChanges();
        if (this.counter[matchId] <= 0) {
          this.unSubscribeCoundown();
          this.getMatches();
        }
      });
      this.countDown.push(subs);
    }
    this.myOutput.emit(this.filterArray);
  }

  isTimer(time) {
    let diff = this.getDiffInSeconds(time);
    diff /= (60 * 60);
    const hours = Math.abs(Math.round(diff));
    if (diff <= 0) {
      return false;
    } else if (hours <= 24 && hours >= 0) {
      return true;
    } else {
      return false;
    }
  }

  getDiffInSeconds(time) {
    const now = new Date(); //todays date
    const end = new Date(time * 1000); // another date
    return (end.getTime() - now.getTime()) / 1000;;
  }

  goToContestList(res) {
    // this.navCtrl.navigateRoot(['contest-listing'], { queryParams: { matchDetails: JSON.stringify(res) } });
    this.navCtrl.navigateForward(['contest-listing'], { queryParams: { matchDetails: JSON.stringify(res) } });
  }

  ionViewDidEnter() {
    console.warn(`cricket page => ionViewDidEnter`);
    // this.doRefresh();
  }

  doRefresh(event=null) {
    this.cacheCleartimestamp = new Date().getTime();
    this.unSubscribeCoundown();
    this.getBanners();
    this.getMatches();
    this.getUserWalletBalance();
    if (event) {
      setTimeout(() => {
        event.target.complete();
      }, 2000);
    }
  }

  ngOnDestroy() {
    console.log(`ngOnDestroy - cricketpage`)
    this.unSubscribeCoundown();
    // if (this.ionWillEnterSubscription) {
    //   this.ionWillEnterSubscription.unsubscribe();
    //   this.ionWillEnterSubscription = null;
    // }
    // if (this.pauseListener) {
    //   this.pauseListener.unsubscribe();
    //   this.pauseListener = null;
    // }
    // if (this.resumeListener) {
    //   this.resumeListener.unsubscribe();
    //   this.resumeListener = null;
    // }
  }

  unSubscribeCoundown() {
    if (this.countDown) {
      for (const data of this.countDown) {
        data.unsubscribe();
      }
      this.countDown = [];
    }
  }
}
